<template>
	<ul class="d-flex flex-wrap list-style-none service-list">
		<li
			v-for="(item, index) in items"
			:key="index"
			class="mx-1 my-2 service-item"
			:style="serviceStyles"
		>
			<ServiceBtn
				:id="servicePatient ? 'service-patient-btn-' + index : 'service-ps-btn-' + index"
				:icon-bg-color="iconBgColor"
				:icon-hover-bg-color="iconHoverBgColor"
				:item="item"
				@keydown.tab.exact="lastTabEvent($event, index)"
			/>
		</li>
	</ul>
</template>

<script setup lang="ts">
	import { PropType, computed } from 'vue';
	import BreakpointHelper from '../../helpers/BreakpointHelper';
	import { IndexedObject } from '../../types';
	import { Service } from '../ServiceBtn/types';
	import ServiceBtn from '../ServiceBtn';

	const props = defineProps({
		items: {
			type: Array as PropType<Service[]>,
			required: true,
		},
		servicePatient: {
			type: Boolean,
			default: false,
		},
	});

	const breakpointHelper = new BreakpointHelper();
	const iconBgColor = computed<string>(() => {
		if (props.servicePatient) {
			return '#1CB0BA';
		}
		return '#01B9F5';
	});
	const iconHoverBgColor = computed<string>(() => {
		if (props.servicePatient) {
			return '#006A77';
		}
		return '#005DA8';
	});
	const serviceStyles = computed<IndexedObject>(() => {
		const serviceStyleRules: IndexedObject = {
			flexBasis: 'calc((100% / 3) - 8px)',
			maxWidth: 'calc((100% / 3) - 8px)',
			width: 'calc((100% / 3) - 8px)',
		};

		if (breakpointHelper.is('mdAndUp')) {
			serviceStyleRules.width = 'calc(25% - 8px)';
			serviceStyleRules.maxWidth = 'calc(25% - 8px)';
			serviceStyleRules.flexBasis = 'calc(25% - 8px)';
		}

		if (breakpointHelper.is('xsOnly')) {
			serviceStyleRules.width = 'calc(50% - 8px)';
			serviceStyleRules.maxWidth = 'calc(50% - 8px)';
			serviceStyleRules.flexBasis = 'calc(50% - 8px)';
		}

		return serviceStyleRules;
	});
	const setFocus = (id: string) : void => {
		let element;

		element = document.querySelector('#service-menu-dialog-close-btn') as HTMLElement;
		if (!breakpointHelper.isDesktop() && element !== null && element !== undefined) {
			element.focus();
		}

		if (id !== null) {
			element = document.querySelector(`#${id}`) as HTMLElement;
			if (element !== null && element !== undefined) {
				element.focus();
			}
		}
	};
	const lastTabEvent = (e : KeyboardEvent, index : number): void => {

		if (index === props.items.length - 1 && props.servicePatient) {
			e.preventDefault();
			setFocus('service-menu-home-btn');
		}
	};
</script>
